import { useCallback } from 'react';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';
import CurrentUserInterface from '@api/requests/auth/interfaces/CurrentUserInterface.interface';

import { showToast } from '@app/providers/ToastProvider';
import { store } from '@app/redux/store';

import { CurrentUserFormValues } from '@components/forms/currentUser/interfaces';

import { getDialCode, getNational } from '@utils/phoneFormatter';

import { USER_PROFILE_STEPS_ENUM } from '../userProfileViewsFactory';

function useUserProfileUpdate({
	currentUser,
	setCurrentStep,
}: {
	currentUser: CurrentUserInterface;
	setCurrentStep(value: USER_PROFILE_STEPS_ENUM): void;
}) {
	const { startRequest } = useTriggeredRequest(AccountClientRequests.Users.update);

	const initialValues: CurrentUserFormValues = {
		first_name: currentUser.first_name,
		last_name: currentUser.last_name,
		email: currentUser.email,
		phone: {
			code: getDialCode(currentUser.phone || '') || '',
			number: getNational(currentUser.phone || '') || '',
		},
	};

	const onSubmit = useCallback(
		async (values: CurrentUserFormValues) => {
			try {
				await startRequest({
					first_name: values.first_name,
					last_name: values.last_name,
					email: values.email,
					phone: values.phone.code + values.phone.number,
					branch: store.getState().branchEnvironment.variables.branch_id,
					mfa_enabled: store.getState().auth.currentUser?.mfa_enabled || false,
				});

				setCurrentStep(USER_PROFILE_STEPS_ENUM.INFO);
			} catch (e) {
				showToast.error('Something went wrong.');
			}
		},
		[setCurrentStep, startRequest],
	);

	return {
		initialValues,
		onSubmit,
	};
}

export default useUserProfileUpdate;
